module.exports = __webpack_public_path__ + "img/safari-search-logo.2c2c8abf.png";